export default __webpack_public_path__ + "static/serviceImg2-137a8afa7a734842bde8790535a9cbb0.jpeg";